<template>
  <div class="d-flex align-items-center" :class="alignmentClass">
        <span
            :class="`badge badge-pill badge-${rowData.active ? 'success' : 'danger'} text-capitalize`">
            {{ rowData.active ? 'active' : 'inactive' }}
        </span>
    <span v-if="rowData.trial_expired" class="badge badge-pill badge-dark text-capitalize ml-2">
      {{ $t('trial_expired') }}
    </span>
  </div>
</template>

<script>

export default {
  name: "TenantStatus",
  props: {
    rowData: {},
    alignmentClass: {}
  }
}
</script>
